'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function isNil(x) {
    return x == null;
}
exports.isNil = isNil;
